import { WIDGET_BRAND_WORKFLOW_FILTER_CONFIG } from '../brandWorkflowFilterConfig';
import { useInitializeBrandWorkflowTags } from './useInitializeBrandWorkflowTags';

export const useInitializeWidgetBrandWorkflowTags = (
  shouldHydrateCurrentUser = false,
): boolean =>
  useInitializeBrandWorkflowTags(
    WIDGET_BRAND_WORKFLOW_FILTER_CONFIG,
    shouldHydrateCurrentUser,
  );
